import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { Nav, NavItem } from 'react-bootstrap';

import MissingTicketNumberList from './MissingTicketNumbersList';
import { viewMissing, viewNotExpected } from '../actions';
import { getViewNotExpected, getViewMissing } from '../selectors';


const MISSING_TAB_KEY = 'MISSING_TAB_KEY';
const NOT_EXPECTED_TAB_KEY = 'NOT_EXPECTED_TAB_KEY';


const propTypes = exact({
  activeTab: PropTypes.string.isRequired,
  viewMissingFlag: PropTypes.bool.isRequired,
  viewNotExpectedFlag: PropTypes.bool.isRequired,
  viewMissingAction: PropTypes.func.isRequired,
  viewNotExpectedAction: PropTypes.func.isRequired,
});


const TabbedMissingTicketNumbers = (props) => {
  const {
    activeTab,
    viewMissingFlag,
    viewNotExpectedFlag,
    viewMissingAction,
    viewNotExpectedAction,
  } = props;

  return (
    <div>
      <Nav bsStyle="tabs" activeKey={activeTab}>
        <NavItem eventKey={MISSING_TAB_KEY} onClick={viewMissingAction}>Missing</NavItem>
        <NavItem
          eventKey={NOT_EXPECTED_TAB_KEY}
          onClick={viewNotExpectedAction}
        >
          Not Expected
        </NavItem>
      </Nav>
      <div className="panel panel-default panel-tabbed">
        {
          viewMissingFlag
          && <MissingTicketNumberList only_not_expected={false} />
        }
        {
          viewNotExpectedFlag
          && <MissingTicketNumberList only_not_expected />
        }
      </div>
    </div>
  );
};


TabbedMissingTicketNumbers.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    viewMissingFlag: getViewMissing(state),
    viewNotExpectedFlag: getViewNotExpected(state),
  };
};


const mapDispatchToProps = {
  viewMissingAction: viewMissing,
  viewNotExpectedAction: viewNotExpected,
};


const withRedux = connect(mapStateToProps, mapDispatchToProps);


const withActiveTab = withProps((props) => {
  const { viewMissingFlag, viewNotExpectedFlag } = props;

  if (viewMissingFlag) {
    return { activeTab: MISSING_TAB_KEY };
  } if (viewNotExpectedFlag) {
    return { activeTab: NOT_EXPECTED_TAB_KEY };
  }
  throw new Error(`MissingTicketNumber: Unable to determine activeTab: ${viewMissingFlag} ${viewNotExpectedFlag}`);
});


const enhance = compose(
  withRedux,
  withActiveTab,
);

export default enhance(TabbedMissingTicketNumbers);
